module.exports = __webpack_public_path__ + "static/media/logo-harrison-pt.a1e5222e.png";